import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Icon } from '@iconify/react';
import AssistantSources from './AssistantSources';
import { assistantMarkdownComponents } from './assistantMarkdownComponents';
import { AppSpinner } from '../ui';

export default function AssistantMessage({ message, onRetry }) {
  const isUser = message.role === 'user';

  if (message.loading) {
    return (
      <div className="assistant-message assistant-message--assistant">
        <div className="assistant-message__bubble">
          <div className="d-flex align-items-center gap-8 text-secondary-light">
            <AppSpinner size="sm" centered={false} />
            <span>Recherche dans les documents…</span>
          </div>
        </div>
      </div>
    );
  }

  if (message.error) {
    return (
      <div className="assistant-message assistant-message--assistant">
        <div className="assistant-message__bubble assistant-message__bubble--error">
          <div className="d-flex align-items-start gap-8">
            <Icon icon="mdi:alert-circle-outline" className="text-danger-main mt-2" />
            <div>
              <p className="mb-8">{message.error}</p>
              {onRetry && (
                <button type="button" className="btn btn-outline-danger btn-sm" onClick={onRetry}>
                  Réessayer
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`assistant-message assistant-message--${isUser ? 'user' : 'assistant'}`}>
      <div className="assistant-message__content">
        <div className="assistant-message__bubble">
          {isUser ? (
            <p className="mb-0">{message.content}</p>
          ) : (
            <div className="assistant-message__markdown">
              <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                components={assistantMarkdownComponents}
              >
                {message.content || ''}
              </ReactMarkdown>
            </div>
          )}
        </div>
        {!isUser && <AssistantSources sources={message.sources} />}
      </div>
    </div>
  );
}
